// API utility with automatic Firebase token handling
export const apiCall = async (url, options = {}) => {
  const token = localStorage.getItem('firebaseToken');
  
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers
  });

  if (response.status === 401 || response.status === 403) {
    // Token expired or invalid
    localStorage.removeItem('firebaseToken');
    window.location.reload();
  }

  return response;
};